<template>
  <div class="country-flag" v-bind:class="{ selected: selected }">
    <div class="flag-container">
      <div class="flag" :style="flag"></div>
    </div>
    <span class="name">{{ name }}</span>
  </div>
</template>

<script>
export default {
  name: "CountryFlag",
  props: {
    countryFlag: {
      type: String,
      default: "",
    },
    countryName: {
      type: String,
      default: "",
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    flag() {
      return {
        backgroundPosition: "center center",
        backgroundSize: "cover",
        backgroundImage: 'url("' + this.countryFlag + '")',
      };
    },
    name() {
      return this.countryName;
    },
  },
};
</script>

<style lang="scss">
@import "src/assets/scss/colors";
.country-flag {
  cursor: pointer;
  width: 100%;
  max-width: 100%;
  margin: auto;

  .flag-container {
    max-width: 100%;
    width: 80px;
    margin: auto;
    .flag {
      padding: 50%;
      height: 0px;
      border-radius: 100px;
    }
  }

  .name {
    font-size: 1em;
    font-weight: lighter;
    color: white;
    width: 100%;
    margin-top: 0.5em;
    text-align: center;
    display: block;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    max-lines: 1;
  }
  &.selected {
    .name {
      font-weight: bold;
    }
    .flag {
      border: 2px solid $red;
      &:before {
        content: "";
        position: absolute;
        width: 76px;
        height: 76px;
        border-radius: 100px;
        background: #0c111b;
        opacity: 0.7;
      }
      &:after {
        content: "";
        position: absolute;
        width: 76px;
        height: 76px;
        border-radius: 100px;
        background: url("/img/flags/check-circle.svg") no-repeat center center;
        background-size: 2.3em;
      }
    }
  }
}
</style>
